module.exports = __webpack_public_path__ + "img/bg_recruit.47fd31d0.png";